<template>
  <div class="container-fluid">
    <form >
      <input class="mb-3"
        type="number"
        v-model="count"
        :max="ordersCount"
      >

      <b-button class="float-end ms-3"
        variant="success"
        type="submit"
                :disabled="db"
      >
        {{$t('modal.button.get')}}
      </b-button>

      <b-button class="float-end"
        variant="warning"
        @click="onClose"
      >
        {{$t('modal.button.back')}}
      </b-button>
    </form>
  </div>
</template>

<script>
  export default {
    name: "GetBottle",
    props: {
      ordersCount: {
        type: Number,
        require: true
      }
    },
    data() {
      return {
        count: 1,
        db: false,
      }
    },
    methods: {
      onClose() {
        this.$emit('onClose')
      }
    }
  }
</script>